import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import {
  BetmenList,
  BetmenListHeader,
  BetmenListHeaderCell,
  BetmenListBody,
  BetmenListItemCard,
  BetmenListItemCardCell,
} from '../../../../../common/components'
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined'
import { UsePatientEProfileReturn } from '../../hooks/usePatientEProfile'
import { PatientDetailsSectionHeader } from './PatientDetailsSectionHeader'
import { PatientDetailsActions } from './PatientDetailsActions'

export const PatientSurgeries: React.FC<UsePatientEProfileReturn> = ({
  patientDetails,
  isLoading,
  isEditable,
}) => {
  const { t } = useTranslation()
  const hasData = patientDetails.surgeries.length > 0

  return (
    <Box bgcolor={'primary.200'} py={2} borderRadius={3}>
      <PatientDetailsSectionHeader
        icon={<VolunteerActivismOutlinedIcon fontSize="large" />}
        title={t('doctor:patientProfile.surgeries.title')}
        hasData={hasData}
      />

      {(isLoading || hasData) && (
        <BetmenList
          dataSource={patientDetails.warnings}
          loading={isLoading}
          gridColumnSizes={[7, 2, 2, 1]}
          extraHeaderStyle={{ backgroundColor: 'transparent' }}
          stickyHeader={false}
          header={
            <BetmenListHeader>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.surgeries.header.name')}
              </BetmenListHeaderCell>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.surgeries.header.type')}
              </BetmenListHeaderCell>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.surgeries.header.date')}
              </BetmenListHeaderCell>
            </BetmenListHeader>
          }
        >
          <BetmenListBody>
            {patientDetails.surgeries.map((surgery) => (
              <BetmenListItemCard key={surgery.id}>
                <BetmenListItemCardCell typographyProps={{ fontWeight: 700 }}>
                  {surgery.name}
                </BetmenListItemCardCell>
                <BetmenListItemCardCell>
                  {t(
                    `doctor:patientProfile.surgeries.type.${surgery.type.toLowerCase()}`
                  )}
                </BetmenListItemCardCell>
                <BetmenListItemCardCell typographyProps={{ fontWeight: 400 }}>
                  {t('common:intlDateFormattedLongMonth', {
                    date: surgery.date,
                  })}
                </BetmenListItemCardCell>

                <PatientDetailsActions isEditable={isEditable} />
              </BetmenListItemCard>
            ))}
          </BetmenListBody>
        </BetmenList>
      )}
    </Box>
  )
}
